<nb-card class="form" [formGroup]="form">
  <nb-card-header
    ><h4>
      {{ "dialogs.embedding.title" | translate }}
    </h4></nb-card-header
  >
  <nb-card-body>
    <p>
      {{ "dialogs.embedding.description" | translate }}
    </p>

    <nb-form-field>
      <label for="role" class="label col-sm-3 col-form-label">
        {{ "input.apiKey.label" | translate }}
      </label>

      <nb-select
        formControlName="apiKey"
        [status]="showInputError('role') ? 'danger' : 'basic'"
      >
        <nb-option
          *ngFor="let a of usageService.apiKeys$.value"
          [value]="a.clear_api_key"
          >{{ a.name }}</nb-option
        >
      </nb-select>
    </nb-form-field>

    <nb-form-field>
      <label for="role" class="label col-sm-3 col-form-label">
        {{ "input.tutorSelect.label" | translate }}
      </label>

      <nb-select
        formControlName="botId"
        [status]="showInputError('role') ? 'danger' : 'basic'"
      >
        <nb-option
          *ngFor="let t of tutorService.tutors$.value"
          [value]="t.id"
          >{{ t.name }}</nb-option
        >
      </nb-select>
    </nb-form-field>

    <textarea
      nbInput
      fullWidth
      rows="6"
      [value]="scriptTag"
      placeholder="Bitte API-Key und KI-Agent auswählen"
    ></textarea>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="danger"
      (click)="dialogRef.close(true)"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button
      type="submit"
      nbButton
      status="primary"
      outline=""
      [disabled]="scriptTag"
      (click)="copyToClipboard()"
    >
      {{ "buttons.copy" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
